import React, { useEffect, useRef, useState } from "react";
import style from './editChannelModal.module.scss';
import Button from "../Button/button"
import Input from '../input/input';
import Modal from "../Modal/Modal"
import EmailRegex from '../../helpers/actions/emailRegex'
import PhoneNumberRegex from '../../helpers/actions/phoneNumberRegex'
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";


const EditChannelModal = (props) => {

    const [editModal, setEditModal] = useState({
        value: props.email ? props.email : '',
        err: '',
        passwordValue: '',
        passwordErr: '',
        confirmCode: '',
        confirmCodeErr: ''
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {

    }, []);

    const onchangeHandler = (tag, e) => {
        let tmp = editModal
        tmp.err = ''
        tmp.passwordErr = ''
        if (tag == 'editPassword') {
            tmp.passwordValue = e.target.value
        }
        if (tag == 'editEmail') {
            tmp.value = e.target.value
        }
        setEditModal({ ...tmp })
    }

    const onBlureHandler = () => {
        // DO NOTHING
    }

    const buttonHandler = async () => {
        let tmp = editModal
        if (!EmailRegex(tmp.value) && !PhoneNumberRegex(tmp.value)) {
            tmp.err = "فرمت ایمیل یا تلفن همراه را اصلاح کنید!"
            setEditModal({ ...tmp })
        } else {
            if (editModal.passwordErr == "") {
                tmp.passwordErr = "تکمیل این فیلد الزامی است!"
                setEditModal({ ...tmp })
            } else {
                setLoading(true)
                tmp.err = ""
                tmp.passwordErr = ""
                setEditModal({ ...tmp })

                let res = await props.editchannel(toEnglishNumber(editModal.value), editModal.passwordValue)
                if (res) {
                    setLoading(false)
                    props.closemodal()
                } else {
                    setLoading(false)
                    let tmp = editModal
                    if (props.email) {
                        tmp.passwordErr = 'ویرایش رمزعبور با خطا مواجه شد'
                    } else {
                        tmp.passwordErr = 'ثبت پنل با خطا مواجه شد'
                    }
                    setEditModal({ ...tmp })
                }
            }
        }
    }

    return (
        <Modal
            value={props.show}
            title={props.email ? "ویرایش" : "ثبت پنل جدید"}
            parentClose={() => props.closemodal()}
        >
            <div className={style.contentWrapper}>
                <Input
                    label="ایمیل یا شماره موبایل"
                    placeholder="ایمیل یا شماره موبایل"
                    tag="editEmail"
                    disabled={props.email ? true : false}
                    type="email"
                    value={editModal.value}
                    error={editModal.err}
                    tooltip={"ایمیل یا شماره موبایل ثبت شده در پنل دیجی‌کالا"}
                    onchange={onchangeHandler}
                    onblur={onBlureHandler} />
                <div className={style.space}></div>
                <Input
                    type="password"
                    label="رمز عبور"
                    placeholder="رمز عبور"
                    tag="editPassword"
                    value={editModal.passwordValue}
                    error={editModal.passwordErr}
                    tooltip={"رمز عبور پنل فروشندگان دیجی‌کالا"}
                    onchange={onchangeHandler}
                    onblur={onBlureHandler} />
                <div className={style.space}></div>
                {/* <Input
                        label=" ارتباط از طریق api"
                        placeholder=" ارتباط از طریق api"
                        tag="apiConnection"
                        value={addModal.passwordValue}
                        error={addModal.passwordErr}
                        tooltip={" api نمایش داده شده در پروفایل دیجی‌کالا  "}
                        onchange={onchangeHandler}
                        onblur={onBlureHandler} /> */}
                {props.email ? <div className={style.caution}>
                    <p> رمز عبور خود را تنها در صورت تغییر رمز عبور در پنل دیجی‌کالا خود تغییر دهید.
                        در غیر این صورت ارتباط ربات با پنل شما قطع خواهد شد.
                    </p>
                    <div className={style.icon}>h</div>
                </div>
                    :
                    <div className={style.caution}>
                        <p>
                            اتصال به پنل دیجی‌کالا به‌دلیل تغییر فرآیند‌ها در دیجی‌کالا ممکن است با تاخیر انجام شود
                        </p>
                        <div className={style.icon}>h</div>
                    </div>
                }

                <div className={style.space}></div>
                <div className={style.buttonWrapper}>
                    <div className={style.button}>
                        <Button
                            disabled={editModal.passwordErr || editModal.err || !editModal.passwordValue ? true : false}
                            tag="editSubmit"
                            loading={loading}
                            type="solid"
                            label="ثبت تغییرات"
                            onclick={buttonHandler} />
                    </div>
                    <div className={style.button}>
                        <Button
                            disabled={false}
                            tag="editCancel"
                            type="outline"
                            label="انصراف"
                            onclick={() => props.closemodal()} />
                    </div>


                </div>
            </div>
        </Modal >
    )
}
export default EditChannelModal